import { Input, InputProps } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./ItemChooserSearch.module.scss";
import clsx from "clsx";

const ItemChooserSearch: React.FC<InputProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Input
      {...props}
      placeholder={t("failure.itemChooserSearch.searchPlaceholder")}
      className={clsx(styles.input, props.className)}
    />
  );
};

export default ItemChooserSearch;
